  (function () {
    if (window.__croPdpBuyNow) return;
    window.__croPdpBuyNow = true;

    function croPdpNeedsSize() {
      var picker = document.querySelector('.product-information variant-picker');
      if (!picker || typeof picker.hasCompleteSelection !== 'function') return false;
      if (picker.hasCompleteSelection()) return false;
      if (typeof picker.promptMissingSelection === 'function') picker.promptMissingSelection();
      return true;
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-cro-pdp-buynow]');
      if (!trigger) return;
      event.preventDefault();
      if (croPdpNeedsSize()) return;

      var pay =
        document.querySelector('.product-details .shopify-payment-button__button') ||
        document.querySelector('.product-details shopify-accelerated-checkout button') ||
        document.querySelector('.product-details shopify-accelerated-checkout [role="button"]');

      if (pay) pay.click();
    });

    function croReturnsCopy(html) {
      if (!html) return html;
      return html
        .replace(/7 Days Free Returns\s*&amp;\s*Exchange/gi, '7-Day Easy Exchange')
        .replace(/7 Days Free Returns\s*&amp;\s*Exchange/gi, '7-Day Easy Exchange')
        .replace(/7 Days Free Returns\s*&\s*Exchange/gi, '7-Day Easy Exchange')
        .replace(/7 Days Free<br\s*\/?>Returns<br\s*\/?>&amp; Exchange/gi, '7-Day Easy Exchange')
        .replace(/7-day easy exchange only\s*[-–—]\s*No Returns/gi, '7-Day Easy Exchange')
        .replace(/7 day easy exchange only\s*[-–—]\s*No Returns/gi, '7-Day Easy Exchange')
        .replace(/7-day easy exchange only/gi, '7-Day Easy Exchange')
        .replace(/7-day easy returns\s*&amp;\s*exchanges/gi, '7-Day Easy Exchange')
        .replace(/7-day easy returns\s*&\s*exchanges/gi, '7-Day Easy Exchange')
        .replace(/Easy returns and exchanges/gi, '7-Day Easy Exchange')
        .replace(/Easy returns &amp; exchanges/gi, '7-Day Easy Exchange')
        .replace(/Easy returns & exchanges/gi, '7-Day Easy Exchange')
        .replace(/7-day return window/gi, '7-Day Easy Exchange')
        .replace(/7 Days Returns and Exchanges?/gi, '7-Day Easy Exchange');
    }

    function croFixReturnsCopy(scope) {
      var root = (scope || document).querySelector('.product-information');
      if (!root) return;
      root.querySelectorAll('.accordion .details-content').forEach(function (node) {
        var next = croReturnsCopy(node.innerHTML);
        if (next !== node.innerHTML) node.innerHTML = next;
        var seen = {};
        node.querySelectorAll('li').forEach(function (li) {
          var key = (li.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
          if (!key) return;
          if (seen[key]) li.remove();
          else seen[key] = true;
        });
      });
    }

    function parkModelLine(scope) {
      var root = (scope || document).querySelector('.product-information .product-details');
      if (!root) return;

      var option =
        root.querySelector('variant-picker .variant-option--buttons') ||
        root.querySelector('variant-picker .variant-option');
      if (!option) return;
      if (option.querySelector('[data-cro-pdp-model]')) return;

      var home = root.querySelector('[data-cro-pdp-model-home]');
      if (!home) {
        root.querySelectorAll('.shopify-block').forEach(function (block) {
          if (home) return;
          var text = (block.textContent || '').replace(/\s+/g, ' ').trim();
          if (/^Model is /i.test(text) && text.length < 80) home = block;
        });
      }
      if (!home) return;

      var line = document.createElement('p');
      line.className = 'cro-pdp-model';
      line.setAttribute('data-cro-pdp-model', '1');
      line.textContent = (home.textContent || '').replace(/\s+/g, ' ').trim();
      option.appendChild(line);
      home.setAttribute('data-cro-pdp-model-home', '1');
    }

    function croFitProductTitle() {
      var heading = document.querySelector('.product-details h1');
      if (!heading) return;
      var box = heading.parentElement;
      if (!box) return;
      box.style.setProperty('overflow', 'visible', 'important');
      box.style.setProperty('display', 'block', 'important');
      box.style.setProperty('min-width', '0', 'important');
      box.style.setProperty('max-width', '100%', 'important');
      var wide = window.innerWidth >= 750;
      var size = wide ? 20 : 18;
      heading.style.setProperty('font-weight', '600', 'important');
      heading.style.setProperty('letter-spacing', '-0.02em', 'important');
      heading.style.setProperty('line-height', '1.3', 'important');
      heading.style.setProperty('display', 'block', 'important');
      heading.style.setProperty('width', '100%', 'important');
      heading.style.setProperty('max-width', '100%', 'important');
      heading.style.setProperty('min-width', '0', 'important');
      heading.style.setProperty('font-size', size + 'px', 'important');
      heading.style.setProperty('white-space', 'normal', 'important');
      heading.style.setProperty('text-wrap', 'wrap', 'important');
      heading.style.setProperty('overflow', 'visible', 'important');
      heading.style.setProperty('text-overflow', 'unset', 'important');
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        parkModelLine(document);
        croFixReturnsCopy(document);
        croFitProductTitle();
      });
    } else {
      parkModelLine(document);
      croFixReturnsCopy(document);
      croFitProductTitle();
    }
    document.addEventListener('shopify:section:load', function (event) {
      parkModelLine(event.target || document);
      croFixReturnsCopy(event.target || document);
      croFitProductTitle();
    });
    window.addEventListener('resize', croFitProductTitle);
    document.addEventListener('variant:update', function () {
      parkModelLine(document);
    });

    function croAccordPanel(details) {
      return details.querySelector('.details-content');
    }

    function croAccordReduce() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function croAccordMs(height) {
      return Math.round(Math.min(720, Math.max(420, height * 0.65)));
    }

    function croAccordEase(ms) {
      var time = (ms || 480) + 'ms';
      var curve = 'cubic-bezier(0.4, 0, 0.2, 1)';
      return 'height ' + time + ' ' + curve + ', block-size ' + time + ' ' + curve + ', padding-bottom ' + time + ' ' + curve;
    }

    function croIsDesktop() {
      return window.matchMedia && window.matchMedia('(min-width: 750px)').matches;
    }

    function croPanelSet(panel, height, pad, ms) {
      var ease = ms && !croAccordReduce() ? croAccordEase(ms) : 'none';
      panel.style.setProperty('transition', ease, 'important');
      panel.style.setProperty('height', height + 'px', 'important');
      panel.style.setProperty('block-size', height + 'px', 'important');
      panel.style.setProperty('max-height', 'none', 'important');
      panel.style.setProperty('padding', '0 14px ' + pad + 'px', 'important');
      panel.style.setProperty('overflow', 'hidden', 'important');
    }

    function croMeasurePanel(panel) {
      panel.style.setProperty('transition', 'none', 'important');
      panel.style.setProperty('height', 'auto', 'important');
      panel.style.setProperty('block-size', 'auto', 'important');
      panel.style.setProperty('padding', '0 14px 16px', 'important');
      panel.style.setProperty('overflow', 'hidden', 'important');
      var height = Math.ceil(panel.getBoundingClientRect().height);
      panel.style.setProperty('height', '0px', 'important');
      panel.style.setProperty('block-size', '0px', 'important');
      panel.style.setProperty('padding', '0 14px 0px', 'important');
      panel.offsetHeight;
      return height;
    }

    function croAccordArm(details) {
      details.removeAttribute('name');
      details.setAttribute('open', '');
    }

    function croScroller() {
      var wrap = document.querySelector('.page-wrapper');
      if (wrap) {
        var overflow = window.getComputedStyle(wrap).overflowY;
        if ((overflow === 'auto' || overflow === 'scroll') && wrap.scrollHeight > wrap.clientHeight + 2) return wrap;
      }
      return document.scrollingElement || document.documentElement;
    }

    function croReleaseColumn() {
      var col = document.querySelector('.product-information .product-details');
      var section = document.querySelector('.product-information');
      if (section) {
        section.style.transition = 'none';
        section.style.paddingBottom = '';
      }
      if (!col || col.dataset.croHold === '1') return;
      ['position', 'top', 'left', 'width', 'max-width', 'right', 'bottom', 'margin'].forEach(function (prop) {
        col.style.removeProperty(prop);
      });
      delete col.dataset.croFrozen;
    }

    function croFreeze() {
      /* Leave the buy column in flow. Absolute pinning left a blank column when scrolling up. */
      croReleaseColumn();
    }

    function croUnfreeze() {
      croReleaseColumn();
    }

    function croAccordSpace() {
      croReleaseColumn();
    }

    function croHoldColumn(summary) {
      var scroller = croScroller();
      scroller.style.scrollBehavior = 'auto';
      var col = document.querySelector('.product-information .product-details');
      if (!col || !croIsDesktop() || !summary || col.dataset.croHold === '1') return;
      var y = summary.getBoundingClientRect().top;
      col.dataset.croHold = '1';
      col.style.setProperty('position', 'relative', 'important');
      col.style.setProperty('top', 'auto', 'important');
      scroller.scrollTop += summary.getBoundingClientRect().top - y;
    }

    function croCorrectSummary(summary, y) {
      var drift = summary.getBoundingClientRect().top - y;
      if (Math.abs(drift) <= 0.5) return;
      var scroller = croScroller();
      scroller.style.scrollBehavior = 'auto';
      scroller.scrollTop += drift;
    }

    function croReleaseHold() {
      if (document.querySelector('.product-information .accordion details.is-cro-open')) return;
      var col = document.querySelector('.product-information .product-details');
      var scroller = croScroller();
      if (!col || col.dataset.croHold !== '1') {
        scroller.style.scrollBehavior = '';
        return;
      }
      var summary = document.querySelector('.product-information .accordion summary');
      var y = summary ? summary.getBoundingClientRect().top : 0;
      col.style.removeProperty('position');
      col.style.removeProperty('top');
      if (summary) scroller.scrollTop += summary.getBoundingClientRect().top - y;
      if (summary && Math.abs(summary.getBoundingClientRect().top - y) > 2) {
        col.dataset.croHold = '1';
        col.style.setProperty('position', 'relative', 'important');
        col.style.setProperty('top', 'auto', 'important');
        scroller.scrollTop += summary.getBoundingClientRect().top - y;
        return;
      }
      delete col.dataset.croHold;
      scroller.style.scrollBehavior = '';
    }

    function croPinSummary(details, ms) {
      var summary = details.querySelector('summary');
      if (!summary) return;
      croHoldColumn(summary);
      var y = summary.getBoundingClientRect().top;
      var until = performance.now() + (ms || 480) + 90;
      function frame() {
        croCorrectSummary(summary, y);
        if (performance.now() < until) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }

    function croAccordOpen(details) {
      if (details.classList.contains('is-cro-open')) return;
      details.classList.remove('is-cro-closing');
      croAccordArm(details);
      var panel = croAccordPanel(details);
      if (!panel) {
        details.classList.add('is-cro-open');
        return;
      }
      croHoldColumn(details.querySelector('summary'));
      croPanelSet(panel, 0, 0, 0);
      details.classList.add('is-cro-open');
      var height = croMeasurePanel(panel);
      details.dataset.croH = String(height);
      if (croAccordReduce()) {
        croPanelSet(panel, height, 16, 0);
        return;
      }
      var ms = croAccordMs(height);
      croPinSummary(details, ms);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          croPanelSet(panel, height, 16, ms);
        });
      });
    }

    function croAccordClose(details) {
      if (!details.classList.contains('is-cro-open') || details.classList.contains('is-cro-closing')) return;
      var panel = croAccordPanel(details);
      details.classList.add('is-cro-closing');
      delete details.dataset.croH;
      croAccordArm(details);
      var done = false;

      function finish() {
        if (done) return;
        done = true;
        details.classList.remove('is-cro-open');
        details.classList.remove('is-cro-closing');
        if (panel) croPanelSet(panel, 0, 0, false);
        croReleaseHold();
      }

      if (!panel || croAccordReduce()) {
        finish();
        return;
      }

      var height = Math.ceil(panel.getBoundingClientRect().height) || panel.scrollHeight;
      var ms = croAccordMs(height);
      croPinSummary(details, ms);
      croPanelSet(panel, height, 16, 0);
      panel.offsetHeight;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          croPanelSet(panel, 0, 0, ms);
        });
      });
      panel.addEventListener('transitionend', function onEnd(event) {
        if (event.propertyName !== 'height' && event.propertyName !== 'block-size') return;
        panel.removeEventListener('transitionend', onEnd);
        finish();
      });
      setTimeout(finish, ms + 80);
    }

    var croAccordDidInit = false;
    function initPdpAccordion(scope, closeAll) {
      var root = (scope || document).querySelector
        ? (scope || document).querySelector('.product-information .accordion')
        : document.querySelector('.product-information .accordion');
      if (!root) return;
      var rows = root.querySelectorAll('details');
      rows.forEach(function (details) {
        details.removeAttribute('name');
      });
      rows.forEach(function (details) {
        details.setAttribute('open', '');
        if (!closeAll && croAccordDidInit) return;
        details.classList.remove('is-cro-open');
        var panel = croAccordPanel(details);
        if (panel) {
          panel.style.height = '0px';
          panel.style.paddingBottom = '0px';
          panel.style.transition = '';
        }
      });
      croAccordDidInit = true;
      croAccordSpace();
      croFixReturnsCopy(scope || document);
    }

    document.addEventListener(
      'click',
      function (event) {
        var summary = event.target.closest && event.target.closest('.product-information .accordion summary');
        if (!summary) return;
        var details = summary.closest('details');
        if (!details) return;
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        if (details.classList.contains('is-cro-open')) {
          croAccordClose(details);
          return;
        }
        croAccordOpen(details);
      },
      true
    );

    document.addEventListener(
      'toggle',
      function (event) {
        var details = event.target;
        if (!details || !details.closest || !details.closest('.product-information .accordion')) return;
        croAccordArm(details);
      },
      true
    );

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initPdpAccordion(document, true);
      });
    } else {
      initPdpAccordion(document, true);
    }
    document.addEventListener('shopify:section:load', function (event) {
      initPdpAccordion(event.target || document, false);
    });
    if (window.matchMedia) {
      window.matchMedia('(min-width: 750px)').addEventListener('change', function (event) {
        if (event.matches) {
          var open = document.querySelector('.product-information .accordion details.is-cro-open');
          if (open) croFreeze(open);
          croAccordSpace();
          return;
        }
        croUnfreeze();
      });
    }
  })();
